import { render } from "./elem-editor.vue?vue&type=template&id=3783c466&ts=true"
import script from "./elem-editor.vue?vue&type=script&lang=ts"
export * from "./elem-editor.vue?vue&type=script&lang=ts"

import "./elem-editor.vue?vue&type=style&index=0&id=3783c466&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__